import React, {useState} from 'react';
import {Tabs, Tab} from '@mui/material';
import SchoolDashboardShell from '../components/SchoolDashboard.comp';
import {ORANGE} from '../components/widgets.comp';
import CyberRiskProfileTab from '../tabs/CyberRiskProfile.tab';
import CyberRiskByAgeTab from '../tabs/CyberRiskByAge.tab';
import CyberRiskByGenderTab from '../tabs/CyberRiskByGender.tab';

const tabSx = {
    borderBottom: '1px solid #E5E7EB', mb: 3,
    '& .MuiTab-root': {textTransform: 'none', fontWeight: 600, fontSize: '14px', color: '#6A7282', px: 2, whiteSpace: 'nowrap', minHeight: 48},
    '& .Mui-selected': {color: `${ORANGE} !important`},
};

const CyberRisksPage = () => {
    const [tab, setTab] = useState(0);
    return (
        <SchoolDashboardShell
            needsAssessmentResults
            tabs={
                <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto"
                      TabIndicatorProps={{style: {backgroundColor: ORANGE}}} sx={tabSx}>
                    <Tab label="Profile"/>
                    <Tab label="By Age"/>
                    <Tab label="By Gender"/>
                </Tabs>
            }
        >
            {tab === 0 && <CyberRiskProfileTab/>}
            {tab === 1 && <CyberRiskByAgeTab/>}
            {tab === 2 && <CyberRiskByGenderTab/>}
        </SchoolDashboardShell>
    );
};

export default CyberRisksPage;
